import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Helmet } from "react-helmet";

import { BecomeARacepointDealer } from "ducks/BecomeARacepointDealer/index";

export default function BecomeARacepointDealerPage({
  pageContext: { action },
}) {
  return (
    <Fragment>
      <Helmet>
        <title>{"Racepoint Pro - Racepoint Energy"}</title>
      </Helmet>
      <BecomeARacepointDealer action={action} />
    </Fragment>
  );
}

BecomeARacepointDealerPage.propTypes = {
  pageContext: PropTypes.shape({ action: PropTypes.string.isRequired }),
};
